export enum DeployStatus {
  Queued = 'queued',
  InProgress = 'in-progress',
  Successful = 'successful',
  Failure = 'failure',
  Canceled = 'canceled',
  NotStarted = 'notStarted'
}
